import styled from 'styled-components'

type TLabelProps = {
  $isDisabled?: boolean
}

export const SafeAreaTop = styled.div`
  background-color: ${({ theme }) => theme.colors.headerBackground};
  padding-top: env(safe-area-inset-top);
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.headerBackground};
  min-height: 56px;
  padding: 0 4px;
`

export const SideViewContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.background};
  padding: 16px;
  overflow-y: auto;
`

export const TitleLabel = styled.span`
  color: ${({ theme }) => theme.colors.headerText};
  font-size: 18px;
  font-weight: bold;
  flex: 1;
  text-align: center;
`

export const Label = styled.span<TLabelProps>`
  color: ${({ theme, $isDisabled = false }) =>
    $isDisabled ? theme.colors.textDisabled : theme.colors.headerText};
  font-size: 16px;
  font-weight: 600;
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
`
